<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{ $t("My Profile") }}</div>
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper">
                <div class="title small">{{ $t("Personal Information") }}</div>
                <div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("First name:") }}
                    </div>
                    <input
                      type="text"
                      :placeholder="$t('First name')"
                      v-model="name"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("E-mail:") }}
                    </div>
                    <input
                      type="email"
                      :placeholder="$t('E-mail')"
                      v-model="email"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Last name:") }}
                    </div>
                    <input
                      type="text"
                      :placeholder="$t('Last name')"
                      v-model="surname"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Phone:") }}
                    </div>
                    <input
                      type="tel"
                      :placeholder="$t('Phone')"
                      v-model="phone"
                    />
                  </div>
                </div>
                <button class="button long" @click="updateProfileData">
                  <span>{{ $t("Save Changes") }}</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="profileUpdateErrorMessaage">
                    {{ $t(profileUpdateErrorMessaage) }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="profileUpdateSuccessMessaage">
                    {{ $t(profileUpdateSuccessMessaage) }}
                  </div>
                </transition>
              </div>
              <div class="wrapper">
                <div class="title small">{{ $t("Change Password") }}</div>
                <div class="input-container">
                  <div class="desc">
                    <span class="red">*</span> {{ $t("Current password:") }}
                  </div>
                  <input
                    type="text"
                    :placeholder="$t('Current password')"
                    v-model="curPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">
                    <span class="red">*</span> {{ $t("New password:") }}
                  </div>
                  <input
                    type="text"
                    :placeholder="$t('New password')"
                    v-model="newPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">
                    <span class="red">*</span> {{ $t("Confirm password:") }}
                  </div>
                  <input
                    type="text"
                    :placeholder="$t('Confirm password')"
                    v-model="repeatPass"
                  />
                </div>
                <div class="pass-rules">
                  <div class="desc bold">
                    {{ $t("Password must contain:") }}
                  </div>
                  <div class="desc">
                    {{
                      $t(
                        "- At least 6 characters, 1 upper case letter (A-Z), 1 lower case letter (a-z), 1 number (0-9)"
                      )
                    }}
                  </div>
                </div>
                <button class="button long" @click="updatePassword">
                  <span>{{ $t("Save Changes") }}</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="passUpdateErrorMessaage">
                    {{ $t(passUpdateErrorMessaage) }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="passUpdateSuccessMessaage">
                    {{ $t(passUpdateSuccessMessaage) }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="profile-table" v-if="$parent.orderHistory">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title small">{{ $t("Your Orders") }}</div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>{{ $t("ID") }}</td>
                      <td>{{ $t("Date/time") }}</td>
                      <td>{{ $t("Skin name") }}</td>
                      <td>{{ $t("Status") }}</td>
                      <td>{{ $t("Total") }}</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.created_at) }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.status }}</td>
                      <td>{{ item.sum }} {{ item.currency }}</td>
                      <td>
                        <a
                          class="offer-modal-open"
                          @click="$emit('openOrderDetailsModal', item)"
                          >View</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
        <Features />
      </div>
    </div>
  </main>
</template>
<script>
import Features from "../components/Features.vue";

export default {
  name: "Profile",
  props: [],
  components: {
    Features,
  },
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      phone: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
    };
  },
  mounted() {
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        surname: this.surname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              this.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
};
</script>
